import axios from 'axios'
import baseUrl from './baseUrl'

// function getSign(obj) {
//     let currentTime=new Date().getTime();
//     let sing;
//     if(obj.data.params==null){
//         obj.data.params={};
//     }
//     sing =md5(JSON.stringify(obj.data.params)+currentTime+ singkey);
//     // console.log(sing);
//     obj.data.timestamp=currentTime;
//     obj.data.sign=sing;
//     return obj;
// }

const $http = axios.create({
    baseURL: baseUrl.BASE_URL,
    headers:{
        'Content-Type': 'application/json; charset=utf-8'
    }
})
// 添加请求拦截器
$http.interceptors.request.use(function (config) {
    //axios get请求不允许加"Content-Type",插件本身的bug 解决如下：
    if (config.method == 'get') {
        config.data = true;
    }
    return  config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
export default $http;

